import { render, staticRenderFns } from "./NoteTypesTable.vue?vue&type=template&id=39cc3134"
import script from "./NoteTypesTable.vue?vue&type=script&lang=ts"
export * from "./NoteTypesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports